import React from "react";

export const buildPresets = (settings) => [
  { name: "Single Door Scratch Fix", vehicle: "Sedan", size: "medium", panels: [{ key: "door_front_left", repair: "small" }] },
  { name: "Front End Respray", vehicle: "Model 3", size: "medium", panels: [{ key: "bonnet_hood" }, { key: "bumper_front" }, { key: "fender_front_left" }, { key: "fender_front_right" }] },
  {
    name: "Full SUV + Ceramic", vehicle: "SUV", size: "large",
    panels: settings.panels.filter((p) => p.category !== "accessory").map((p) => ({ key: p.key, qty: p.per_unit ? 2 : 1 })),
    services: { ceramic_coating: true },
  },
];

export default function PresetBar({ presets, onApply }) {
  return (
    <div className="flex flex-wrap gap-2">
      {presets.map((p) => (
        <button key={p.name} onClick={() => onApply(p)} data-testid={`preset-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
          className="text-xs font-semibold px-3 py-1.5 rounded-full border border-slate-700 bg-slate-900/60 text-slate-300 hover:border-amber-500/50 hover:text-amber-300 transition-colors">
          {p.name}
        </button>
      ))}
    </div>
  );
}
